import { t } from "i18next";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import Map from "./Map";
const Footer = () => {
  const socialLinks = [
    { icon: faFacebookF, link: "https://www.facebook.com/green.field.company1/" },
  ];

  const quickLinks = [
    t("about_us_link"),
    t("contact_us_link"),
    t("our_services"),
    t("terms_condition"),
    t("support"),
  ];

  const businessHours = [
    { day: t("saturday_thursday"), time: t("time_8_6") },
    { day: t("friday"), time: t("closed") },
  ];

  return (
    <div
      className="container-fluid bg-dark footer mt-5 py-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-4 col-md-6">
            <h4 className="text-primary mb-4">{t("our_office")}</h4>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-primary me-fa"
              />
              {t("location_text")}
            </p>


            <p className="mb-2">
              <FontAwesomeIcon
                icon={faWhatsapp}
                className="text-primary me-fa"
              />
              +218918889391
            </p>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-primary me-fa"
              />
              info@atilal.ly
            </p>
            <div className="d-flex pt-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  className="btn btn-square btn-primary rounded-circle me-2"
                  href={social.link}
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>

          </div>
          <div className="col-lg-4 col-md-6">
            <h4 className="text-primary mb-4">{t("quick_links")}</h4>
            {quickLinks.map((link, index) => (
              <a key={index} className="btn btn-link" href="/">
                {link}
              </a>
            ))}
          </div>
          <div className="col-lg-4 col-md-6">
            <h4 className="text-primary mb-4">{t("business_hours")}</h4>
            {businessHours.map((hour, index) => (
              <div key={index}>
                <p className="mb-1">{hour.day}</p>
                <h6 className="text-light">{hour.time}</h6>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
